import { inputById, inputValue } from './dom';
import { marketingData, multiState, placeData } from './state';
import type { AnalyticsFormData, ServiceEntry, WebhookPayload } from './types';
import { getDeviceType } from './utils';

/**
 * Identyfikatory tego formularza — po nich rozpoznajemy w CRM/analityce,
 * z którego formularza przyszedł deal. Drugi formularz wysyła inne wartości.
 */
export const FORM_VARIANT = 'multitrip_A';
export const FORM_LANDING_VARIANT = 'with_multitrip';

export function serializeForm(): WebhookPayload {
  const countryData = window.iti?.getSelectedCountryData() ?? null;
  const countryOfOrigin = countryData ? countryData.name.replace(/\s*\(.*?\)/, '') : '';
  const isMulti = inputValue('tripType') === 'multitrip';

  const customerDetails = {
    submission_id: crypto.randomUUID(),
    full_name: inputValue('fullName').trim(),
    country_of_origin: countryOfOrigin,
    telephone: window.iti?.getNumber() ?? '',
    source: window.location.origin,
    request_details: inputValue('notes').trim(),
    email: inputValue('email').trim(),
    consent: inputById('marketing')?.checked ?? false,
    device_type: getDeviceType(),
    ab_variant: FORM_VARIANT,
    ab_landing_variant: FORM_LANDING_VARIANT,
    marketing: { ...marketingData, click_id: marketingData.im_ref || '' },
  };

  const servicesData: Record<string, ServiceEntry> = {};
  if (!isMulti) {
    servicesData.service_1 = {
      pickup: inputValue('pickup').trim(),
      destination: inputValue('destination').trim(),
      pickup_date: `${inputValue('pickupDate')} ${inputValue('pickupTime')}`,
      passengers: Number(inputValue('passengers')) || 0,
      carry_on_luggage: Number(inputValue('bags')) || 0,
      checked_luggage: Number(inputValue('seats')) || 0,
      stops: null,
    };
    if (inputValue('tripType') === 'return') {
      servicesData.service_1_return = {
        pickup: inputValue('returnPickup').trim(),
        destination: inputValue('returnDestination').trim(),
        pickup_date: `${inputValue('returnDate')} ${inputValue('returnTime')}`,
        passengers: Number(inputValue('passengers')) || 0,
        carry_on_luggage: Number(inputValue('bags')) || 0,
        checked_luggage: Number(inputValue('seats')) || 0,
        stops: null,
      };
    }
  } else {
    multiState.trips.forEach((trip, idx) => {
      servicesData[`service_${idx + 1}`] = {
        pickup: trip.pickup,
        destination: trip.destination,
        pickup_date: `${trip.date} ${trip.time}`,
        passengers: trip.pax,
        carry_on_luggage: trip.hand,
        checked_luggage: trip.bags,
        stops: trip.stopovers.filter((s) => s.trim() !== ''),
        notes: trip.notes,
      };
    });
  }

  return [{ customer_details: customerDetails, services: [servicesData] }];
}

export function extractFormDataForAnalytics(payload: WebhookPayload): AnalyticsFormData {
  const services = payload[0].services[0];
  const service1 = services.service_1;
  if (!service1) return { transfer_type: 'MULTI_TRIP' };

  const transferType = services.service_1_return ? 'RETURN' : 'ONE_WAY';
  const pickupDateTime = service1.pickup_date ? service1.pickup_date.replace(' ', 'T') + ':00' : '';

  return {
    pickup_country: placeData.pickup?.country || '',
    pickup_city: placeData.pickup?.city || '',
    destination_country: placeData.destination?.country || '',
    destination_city: placeData.destination?.city || '',
    passenger_count: service1.passengers,
    transfer_type: transferType,
    pickup_location: service1.pickup,
    destination: service1.destination,
    pickup_coordinates: placeData.pickup?.coordinates || { longitude: 0, latitude: 0 },
    destination_coordinates: placeData.destination?.coordinates || { longitude: 0, latitude: 0 },
    pickup_local_date: pickupDateTime,
  };
}
